const OPERATORS = {
  PAGE_TITLE: 'اپراتور ها | رایچت',

  HEADING_TITLE: 'لیست اپراتور ها',
  HEADING_SUBTITLE:
    'نمایش ساعات کار و مکالمات هر اپراتور. اعمال تنظیمات، افزودن و حذف اپراتورها در این بخش قابل انجام است.',
  ADD_OPERATOR: 'دعوت اپراتور جديد',

  WEEKLY_CHOSEN_OPERATOR: 'اپراتور منتخب هفته قبل',
  WORKING_HOURS: 'كل ساعات كاری',
  ACCEPTED_CONVS: 'مکالمه‌های قبول شده',
  ACCEPTED: 'قبول شده',
  OPERATORS_SETTINGS: 'تنظیمات اپراتور',
  PROFILE_SETTINGS: 'تنظيمات پروفايل',
  DELETE_OPERATOR: 'حذف اپراتور',
  DELETE_OPERATOR_CONFIRM:
    'آيا تاييد می كنيد #name# از ليست اپراتورهای شما حذف شود؟',

  OPERATORS_LSIT: 'لیست اپراتورها',

  OPERATOR: 'اپراتور',

  USER_PROFILE: 'پروفایل کاربری',
  ADMIN: 'مدیر',

  OPERATOR_MODAL_AVATAR_HINT:
    'ابعاد تصویر باید 60*60 پیکسل و در فرمت png باشد .',
  OPERATOR_MODAL_AVATAR_UPLOAD_IMAGE: 'آپلود تصوير',
  OPERATOR_MODAL_AVATART_DELETE_IMAGE: 'حذف تصوير',

  OPERATOR_MODAL_FORM_TITLE: 'عنوان',
  OPERATOR_MODAL_FORM_FULLNAME: 'نام کامل',
  OPERATOR_MODAL_FORM_EMAIL: 'ایمیل',
  OPERATOR_MODAL_FORM_PASSWORD: 'رمز عبور',
  OPERATOR_MODAL_FORM_PASSWORD_CONFIRM: 'تکرار رمز عبور',

  OPERATOR_MODAL_WEBSITES_LIST_TITLE:
    'اپراتور به این وب‌سایت‌ها دسترسی داشته باشد:',
  OPERATOR_MODAL_ACCESS_LEVEL: 'سطح دسترسی:‌',

  OPERATOR_MODAL_CANCEL: 'انصراف',
  OPERATOR_MODAL_ADD: 'دعوت اپراتور',
  OPERATOR_MODAL_SAVE_CHANGES: 'ذخیره تغییرات',
  OPERATOR_MODAL_SEND_CONFIRM_CODE: 'ارسال کد تایید',

  OVERLAY_TEXT:
    'این قسمت در پکیج رایگان در دسترس نمیباشد.برای استفاده پکیج خود را ارتقا دهید.',
  OVERLAY_CLOSE: 'بستن',

  OPERATOR_WITHOUT_TITLE_LABEL: 'بدون عنوان',
};

export default OPERATORS;
